<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('contacts') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_contact')"
        @click="initContact"
        :loading="savingContact"
        :disabled="savingContact"
      />
    </div>

    <BaseTableLoader :loading="!contacts">
      <ContactTable
        :items="contacts"
        :pagination="contactPagination"
        :loading="loadingContacts"
        @edit="$router.push({ name: 'editContact', params: { id: $event.id } })"
        @update:page="onPageChange"
        @delete="deleteContact"
        @click:image="viewImage"
      />
    </BaseTableLoader>

    <router-view @click:close="closeImage" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ContactTable from '../../components/ContactTable';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import BaseTableLoader from '../../components/base/BaseTableLoader';

export default {
  name: 'Contacts',

  components: {
    BaseTableLoader,
    BasePrimaryActionButton,
    ContactTable,
  },

  created() {
    if (!this.contacts) {
      this.fetchContacts(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.contactFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'contacts'
    ) {
      this.fetchContacts(to.query);
    }
    next();
  },

  computed: mapState('contacts', [
    'contacts',
    'contactPagination',
    'contactFilterParams',
    'loadingContacts',
    'savingContact',
  ]),

  methods: {
    ...mapActions('contacts', ['fetchContacts', 'deleteContact', 'storeContact']),

    initContact() {
      this.storeContact().then((res) => {
        this.$router.push({ name: 'editContact', params: { id: res.data.id } });
      });
    },

    onPageChange(page) {
      const query = { ...this.contactFilterParams, page };
      this.$router.push({ name: 'contacts', query });
    },

    viewImage(image) {
      this.$router.push({ name: 'contacts/image', params: { url: image.image_path } });
    },

    closeImage() {
      this.$router.push({ name: 'contacts' });
    },
  },
};
</script>
